import React from "react";
import "../../../../App.css";
import "../../../_Shared/utility.css";
import "./Redirect.css";
import { FRBanner } from "../../../Banner/Banner";
import { cdn } from "../../../../consts/cdn";

const BannerDesktop =
  cdn.images + "Redirect/Redirect_Banner_Desktop_EU_Compressed.jpeg";
const BannerMobile = cdn.images + "Redirect/Redirect_Banner_Mobile.png";

function Redirect() {
  return (
    <>
      <div className="redirect-FR">
        <FRBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          openSans="true"
          text1="Ce site internet est exclusivement"
          text2="destiné aux professionnels de santé."
          color="#365B7E"
          redirectSubtitle="Si vous êtes une patiente, veuillez contacter votre médecin pour en savoir plus sur le vNOTES."
        />
      </div>
    </>
  );
}

export default Redirect;
